// File: components/TransactionError.tsx
import React from 'react'
import { ThemedText } from 'theme'

interface TransactionErrorProps {
  error?: string
}

const TransactionError: React.FC<TransactionErrorProps> = ({ error }) => {
  if (!error) return null

  return (
    <ThemedText.DeprecatedBody fontSize="14px" fontWeight="400" lineHeight="14px" color="red">
      {error}
    </ThemedText.DeprecatedBody>
  )
}

export default TransactionError
